import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ExternalLink, Wrench, Car, TrendingUp, Calculator, GraduationCap, Megaphone } from 'lucide-react';
import './ProductShowcase.css';

const ProductShowcase = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const products = [
    {
      name: 'Danston Construct',
      description: 'AI-powered Construction Management tool',
      icon: <Wrench size={40} />,
      link: 'https://www.danston.co.in',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      available: true,
    },
    {
      name: 'AutoSector.ai',
      description: "World's 1st AI Management Tool For Entire Automobile Sector",
      icon: <Car size={40} />,
      link: 'https://www.autosector.ai',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      available: true,
    },
    {
      name: 'StockVibes',
      description: "World's 1st GenZ Inspired Free AI Stock Market Analysis Tool With Games",
      icon: <TrendingUp size={40} />,
      link: 'https://www.stockvibes.io',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      available: true,
    },
    {
      name: 'DAP',
      description: 'AI Powered Accounting Software',
      icon: <Calculator size={40} />,
      link: '/coming-soon',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      available: false,
    },
    {
      name: 'Danston Tutor',
      description: "World's smartest and fastest way to learn",
      icon: <GraduationCap size={40} />,
      link: 'https://tutor.danstonai.com',
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      available: true,
    },
    {
      name: 'AIDigi',
      description: 'Your Best Buddy For Digital Marketing Assistant For Content Creators',
      icon: <Megaphone size={40} />,
      link: '/coming-soon',
      gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      available: false,
    },
  ];

  const handleProductClick = (product) => {
    if (product.available) {
      window.open(product.link, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = product.link;
    }
  };

  return (
    <section className="product-showcase" ref={ref} data-testid="product-showcase">
      <div className="container">
        <motion.div
          className="showcase-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title-white" data-testid="showcase-title">
            Our AI Products
          </h2>
          <p className="section-subtitle-white" data-testid="showcase-subtitle">
            Empowering Industries with Intelligent Solutions
          </p>
        </motion.div>

        <div className="products-grid">
          {products.map((product, index) => (
            <motion.div
              key={index}
              className="product-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              onClick={() => handleProductClick(product)}
              whileHover={{ y: -10 }}
              data-testid={`product-${index}`}
            >
              <div className="product-card-inner" style={{ background: product.gradient }}>
                <div className="product-icon">{product.icon}</div>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                
                <div className="product-footer">
                  {product.available ? (
                    <div className="product-status available">
                      <span className="status-dot"></span>
                      Available Now
                    </div>
                  ) : (
                    <div className="product-status coming-soon">
                      <span className="status-dot"></span>
                      Coming Soon
                    </div>
                  )}
                  <ExternalLink size={20} className="external-icon" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
